import { render, staticRenderFns } from "./GenericFormDelete.vue?vue&type=template&id=49939f02&scoped=true&"
import script from "./GenericFormDelete.vue?vue&type=script&lang=js&"
export * from "./GenericFormDelete.vue?vue&type=script&lang=js&"
import style0 from "./GenericFormDelete.vue?vue&type=style&index=0&id=49939f02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49939f02",
  null
  
)

export default component.exports